import Vue from 'vue'

Vue.filter('count', function (value) {
  return _.size(value)
})
